'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ScrollbarSize = require('./ScrollbarSize');

var _ScrollbarSize2 = _interopRequireDefault(_ScrollbarSize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ScrollbarSize2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-scrollbar-size/index.js
// module id = 6278
// module chunks = 39